import moment from 'moment';

export function formatDate ( date, sourceDateFormat, localDateFormat) {
  return moment.utc(date, sourceDateFormat).local().format(localDateFormat)
}